import * as styles from './Checkbox.module.css'

import React from 'react'

export interface Props extends React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> {}

export const Checkbox: React.FC<Props> = (props) => {
  const { ...inputProps } = props

  return <input type="checkbox" className={styles.input} {...inputProps} />
}
